import { useContext } from 'react';
import { Helmet } from 'react-helmet';
import AppContext from 'AppContext';
import styled from 'styled-components';
import { Nav } from 'components/base/nav';
import Advisors from 'components/pages/about/advisors';
import PartnerBanner from 'components/pages/about/partnerbanner';
import Signups from 'components/pages/about/signup';
import Team from 'components/pages/about/team';
import Header from 'components/pages/homepage/homepageheader';
import Content from 'components/utilities/components/Content';
import HorizontalTimeline from 'components/utilities/components/HorizontalTimeline';
import Slides from 'components/utilities/slides';
import { theme } from 'components/utilities/utils';
import Footer from 'components/views/FooterView';
import ProgramSection from 'components/views/ProgramSection';
import Subheader from 'components/views/Subheader';
import FaqComponent from 'components/views/faq';

const Section = styled.section`
  text-align: center;
  padding: 0px;
  background: ${(props) => props.theme.colors.white};
  max-width: 1280px;
`;

const Partners = styled(PartnerBanner)`
  padding-top: 50px;
`;

const PAGE_NAME = 'raise';

export default function RaisePage() {
  const { content, programs } = useContext(AppContext);

  return (
    <Section>
      <Helmet>
        <title>Parkdale Centre for Innovation</title>
        <meta
          name="description"
          content="Grow your idea, join a community, get traction, and see your project through at Parkdale Centre"
        />
        <meta property="og:title" content="Parkdale Centre" />
        <meta property="og:image" content="images/previews/incubators.png" />
        <meta
          property="og:url"
          content="https://www.parkdaleinnovates.org/programs"
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="Incubate your Startup, Business or Career at Parkdale Centre."
        />
        <meta
          property="og:description"
          content="Grow your idea, get traction, and scale your work at Parkdale Centre. You bring the motivation."
        />
        <meta property="og:image" content="images/previews/incubators.png" />
      </Helmet>
      <Header
        pageName={PAGE_NAME}
        color={
          content.programs.Headers['Header text background color'] ||
          theme.colors.purple4
        }
        nav={<Nav />}
        showNavigation
        showLanguageSelector
      />
      <Subheader
        pageName={PAGE_NAME}
        section="SubHeaders"
        lcolor2="red"
        rcolor1={theme.colors.white}
        borderleft={theme.colors.gray5}
        borderright="transparent"
      />
      <HorizontalTimeline
        pageName={PAGE_NAME}
        listName="Metric"
        titleName="MetricHero"
        scroll
      />
      <Slides pageName={PAGE_NAME} section="Carousel1" size="joint" />
      <Content content={programs.raise}>
        <ProgramSection
          color={content.raise.Footer.ThemeColor}
          programName="raise"
        />
      </Content>
      <Team id="team" pageName="raiseteam" title="RAISE Team" />
      <Advisors
        id="raiseadvisors"
        folder="raiseadvisors"
        pageName="raiseadvisors"
        title="RAISE Advisors"
        margin="40px auto 0px"
      />

      <Partners
        id="partners"
        title="Funded By"
        pageName="raise"
        margin="0px auto 0px"
      />

      <FaqComponent pageName={PAGE_NAME} />
      <Signups pageName={PAGE_NAME} />
      <Footer pageName={PAGE_NAME} />
    </Section>
  );
}
